module.exports = __webpack_public_path__ + "fonts/WorkSans-VariableFont_wght.a334cdd.ttf";